import pageContext from 'salvo-lite/context'
import SiteHeader from './components/SiteHeader'
import Slider from './components/Slider'
import ProductForm from './components/ProductForm'
import TextCounter from './helpers/TextCounter'
import HomepageNewLines from './components/HomepageNewLines'
import MobileMenu from './components/MobileMenu'
import ProductMeta from './components/ProductMeta'
import CollectionFilter from './components/CollectionFilter'
import CollectionFilterMaster from './components/CollectionFilterMaster'
import CollectionPerRow from './components/CollectionPerRow'
import BackToTop from './components/BackToTop'
import ReadMore from './components/ReadMore'
import ChangeClass from './components/ChangeClass'
import CartPage from './components/CartPage'
import ProductZoom from './components/ProductZoom'
import CartNotification from './components/CartNotification'
import ProductCardForm from './components/ProductCardForm'
import CopyToClipboard from './components/CopyToClipboard'
import PageSideMenu from './components/PageSideMenu'
import BlogLanding from './components/BlogLanding'
import LoginRegister from './components/LoginRegister'
import SelectLink from './components/SelectLink'
import ArticleVideoContainer from './components/ArticleVideoContainer'
import NavScroll from './components/NavScroll'
import FormValidate from './components/FormValidate'
import ForgotPassword from './components/ForgotPassword'
import CurrencyForm from './components/CurrencyForm'
import Links from './components/Links'

const components = {
    'site-header': SiteHeader,
    'slider': Slider,
    'product-form': ProductForm,
    'text-counter': TextCounter,
    'new-lines': HomepageNewLines,
    'mobile-menu': MobileMenu,
    'product-meta-tabs': ProductMeta,
    'collection-filter': CollectionFilter,
    'collection-filter-master': CollectionFilterMaster,
    'collection-per-row': CollectionPerRow,
    'back-to-top': BackToTop,
    'read-more': ReadMore,
    'change-class': ChangeClass,
    'cart-page': CartPage,
    'zoom': ProductZoom,
    'cart-notification': CartNotification,
    'product-card-form': ProductCardForm,
    'copy-to-clipboard': CopyToClipboard,
    'page-side-menu': PageSideMenu,
    'blog-landing': BlogLanding,
    'login-register': LoginRegister,
    'select-link': SelectLink,
    'article-video-container': ArticleVideoContainer,
    'nav-scroll': NavScroll,
    'form-validate': FormValidate,
    'forgot-password': ForgotPassword,
    'currency-form': CurrencyForm,
    'links': Links
}

const pages = {
}

class Theme {
    constructor () {
        this._components = []
        this._componentsById = {}
    }

    registerComponents () {
        for (let key in components) {
            var ComponentConstructor = components[key]
            var elements = document.querySelectorAll(`.js-component__${key}, [data-${key}]`)
            for (let elem of elements) {
                var instance = new ComponentConstructor(this, elem)
                this._components.push(instance)
                var id = elem.dataset.componentId
                if (id) {
                    this._componentsById[id] = instance
                }
                instance.onInit()
            }
        }
        window.ThemeComponents = this._components
        window.ThemeComponentsId = this._componentsById
        window.__Theme = this
    }

    registerPages () {
        var context = pageContext.getTemplate()
        for (let page in pages) {
            if (page === context) {
                var instance = new pages[page](this)
                instance.onInit()
            }
        }
    }

    getComponents () {
        return this._components
    }

    getComponentsById (id) {
        return this._componentsById[id]
    }

    getComponentsByType (componentConst, includeSubclasses = true) {
        var r = []
        for (let c of this._components) {
            if (includeSubclasses && c instanceof componentConst) {
                r.push(c)
            } else if (c.constructor === componentConst) {
                r.push(c)
            }
        }
        return r
    }
    getComponentByName (name) {
        var r = null
        for (let c of this._components) {
            if (c.name === name) {
                r = c
            }
        }
        return r
    }
}

export default Theme



// WEBPACK FOOTER //
// ./src/resources/scripts/Theme.js